import { useContext, useEffect } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { getArticleDateTime } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../service/wp-blogs-store'

export async function getStaticProps() {

    const { modifiedDate, month, year } = getArticleDateTime();
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

  return {
      props: {
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>Low Reps vs High Reps | Which is better for you?</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Low reps with heavy weight increases strength, high reps with light weight increases endurance. Personal trainers corrects our reps as per our fitness goals."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/low-reps-vs-high-reps" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Low Reps vs High Reps | Which is better for you?`}/>
        <meta property="og:description" content="Low reps with heavy weight increases strength, high reps with light weight increases endurance. Personal trainers corrects our reps as per our fitness goals." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-15T07:30:46+00:00" />
        <meta property="article:modified_time" content="2025-01-04T07:30:46+00:00" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/fitness-girl-lateral-raises.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/fitness-girl-lateral-raises.webp" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/low-reps-vs-high-reps"/>
        <meta name="twitter:title" content={`Low Reps vs High Reps | Which is better for you?`}/> 
        <meta name="twitter:description" content="Low reps with heavy weight increases strength, high reps with light weight increases endurance. Personal trainers corrects our reps as per our fitness goals."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/low-reps-vs-high-reps" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/low-reps-vs-high-reps"},"headline":"Low Reps vs High Reps | Which is better for you?","description":"Low reps with heavy weight increases strength, high reps with light weight increases endurance. Personal trainers corrects our reps as per our fitness goals.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/fitness-girl-lateral-raises.webp"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-15T07:30:46+00:00","dateModified":"2022-09-04T07:30:46+00:00"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/blogs"},{"@type":"ListItem","position":1,"name":"low-leps-vs-high-reps"}]}]}`
          }}
        />
      </Head>
      <div className='max-w-5xl mx-auto py-5 px-2'>
            <div className='space-y-2'>
                <h1 className='text-lg text-gray-500 font-semibold'>Low repetitions vs High repetitions in weight training - Which is better for you?</h1>
                <div className='text-gray-400 text-xs'>
                    <time dateTime="2022-07-16 00:00">July 16th 2022</time>
                </div>
            </div>
            <div className='py-2 text-gray-500 leading-8 space-y-2'>
                <div className='py-2'>
                    <p className=''>
                    When it comes to work out and fitness, often it is found that people are in a dilemma as to whether to go for lower reps or higher reps. High reps help us to lose fat and make our muscle more “toned”. On the other hand, low reps help us to build muscle and increase our body strength. Moreover, researchers have found out that, low repetitions with heavy weights increases strength, whereas high repetitions with light weight increases endurance. The best idea is to take proper guidance and training from a personal trainer as they have the best knowledge and can train as per our goal and body type.
                    </p>
                </div>
                <div className='py-2 space-y-2'>
                    <p>
                        However, the number of reps varies as per what our goal is i.e. for strength, fat loss, muscle building etc the type and number of reps does varies.
                    </p>
                </div>
                <div className='relative h-96 max-w-xl'>
                    <Image className='rounded-lg'
                            src={s3Static + "blog/health+and+fitness/fitness-girl-lateral-raises.webp"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='fitness girl lateral raises'
                    />          
                </div>
                <div className='py-2 space-y-2'>
                    <h2 className='text-lg'>
                        High repetitions and low repetions for different fitness goals
                    </h2>
                </div>
                <div className='py-2 space-y-2'>
                        <h3 className='font-bold'>
                             1. High Reps vs Low Reps – When our goal is to increase our Strength:
                        </h3>
                        <p>
                            It is mostly seen that for optimal results it is advised to lift heavier weights for low reps. By this way, we can get stronger either as a result of increase in muscle size or because of increase in neuromuscular adaptation.
                        </p>
                        <h3 className='font-bold'>
                             2. High Reps vs Low Reps – When our goal is to build Muscle:
                        </h3>
                        <p>
                        There is always a debate on whether high or low reps are best when it comes to muscle building. As per some studies 15 reps are good for muscle building and some studies point out using light weight and high reps we can achieve more toned up muscles. If our goal is to build bigger muscle like bodybuilders, then usually it is seen that working out with high reps helps. This is often called as “structural hypertrophy”.
                        </p>
                        <h3 className='font-bold'>
                             3. High Reps vs Low Reps – When our goal is to lose Fat:  
                        </h3>
                        <p>
                        There is a long-standing debate as to which is better for fat loss. People argue on two ideas i.e. Should we workout with heavy weights and low reps or with Lighter weights and higher reps. It is believed, that, high reps are the key to get rid of fat. However, recent studies shows that more than the amount of weight or the number of repetitions , it is the intensity of the workout that helps to burn more fat. It is worthy of mention here that right nutrition has much greater impact when we want to lose fat.
                        </p>
                        
                </div>
                <div className='py-2 space-y-2'>
                    <p>
                        It is interesting to note that while high reps adds strength, promotes hypertrophy, build muscle low reps on the other hand, build neuromuscular and CNS efficiency. Hence the best idea is to religiously do both high-rep and low-rep ranges to optimize our development and reach our target in a more effective manner.
                    </p>
                    <p>
                        It is mostly seen that for optimal results it is advised to lift heavier weights for low reps. By this way, we can get stronger either as a result of increase in muscle size or because of increase in neuromuscular adaptation.
                    </p>
                </div>
                <div className='py-2 text-center'>
                    <Link href="/sg/personal-trainer" className='px-3 py-3 border border-amber-600 text-orange-600 rounded-lg'>
                            Train with a certified personal trainer in Singapore
                    </Link>
                </div>
            </div>
            <h2 className='text-center text-xl uppercase pt-10'>You may also like</h2>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
        <div className='fixed bottom-0 w-full text-center text-lg'>
            <Link href="/sg/personal-trainer" prefetch={false} className='text-white py-3 bg-linear-to-tr from-amber-600 to-amber-400 block font-bold w-full'>
                    Train with a certified personal trainer in Singapore
            </Link>
        </div>
        <BlogHeaderLinks/>
        <Script 
            id="google-tagmanager-new"
            src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
            strategy="lazyOnload"
            onLoad={() => {              
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
            
                gtag('config', 'G-QD1HGGHDYJ');
            }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
